<template>
<md-card>
    <md-card-header class="md-card-header-icon md-card-header-site">
        <div class="card-icon">
            <md-icon>assignment</md-icon>
            <span class="title page-title" style="font-size: 1.2rem">RELATÓRIOS</span>
        </div>
        <div style="margin-top:4px" v-if="nivel === 5 || nivel === 12">
            <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'Dashboard' }">
                <i class="fas fa-arrow-left"></i>
                <md-tooltip md-direction="top">Relatórios</md-tooltip>
            </md-button>
        </div>
    </md-card-header>

    <md-card-content>
        <relatorio-adm />
        <relatorio-fornecedor />
        <relatorio-financeiro />
        <relatorio-frota />
        <relatorio-rh />
    </md-card-content>

</md-card>
</template>

<script>
import RelatorioAdm from '@/pages/Relatorio/RelatorioAdm'
import RelatorioFinanceiro from '@/pages/Relatorio/RelatorioFinanceiro'
import RelatorioFornecedor from '@/pages/Relatorio/RelatorioFornecedor'
import RelatorioFrota from '@/pages/Relatorio/RelatorioFrota'
import RelatorioRh from '@/pages/Relatorio/RelatorioRh'
import Notify from '@/config/mixins/notify'

export default {
    components: {
        RelatorioAdm,
        RelatorioFinanceiro,
        RelatorioFornecedor,
        RelatorioFrota,
        RelatorioRh,
    },

    mixins: [Notify],

    data() {
        return {
            permissoes: this.$store.state.usuario.permissao,
            nivel: this.$store.state.usuario.niveis[0].id
        }
    },

    created() {
        this.authorize();
    },

    methods: {
        authorize() {
            this.$http.get(this.$urlAPI + 'autorizado').then(response => {}).catch(e => { this.msgErrors(e) })
        }
    }
};
</script>

<style>
.icon-relatorio {
    margin-right: 5px;
    color: #002bdc;
}

.text-relatorio {
    font-size: 0.9rem !important;
    color: #626161;
}
</style>
